import React,{useState,useEffect,useRef} from 'react'
import {
    FormControl,
    FormLabel,
    Input,
    Button,
    Box,
    Text,
    TableContainer,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableCaption,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Checkbox,
    useToast,
    Select
} from "@chakra-ui/react";
import axios from 'axios'
import { useReactToPrint } from 'react-to-print';
import  toast  from 'react-hot-toast';


const Maintanance=()=>{
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    const customerId=localStorage.getItem('customerId')

    const token=localStorage.getItem('token');
    const [data,setData]=useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [editItemId, setEditItemId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const cancelRef = useRef();
    const [formData, setFormData] = useState({
      query: "",
    raisedBy:"",
    date:"",
    solved:false,
    solvedDate:""
    
      
    });

 

  //const customerId=localStorage.getItem('customerId');



  const fetchData=async()=>{
    try {
      const response=await axios.get(`https://api.hotel.tdrsoftware.in/api/getQuery/${customerId}`)
      setData(response.data)
      console.log(response.data)
    } catch (error) {
      toast.error(error.message)
    }
  }
const edit=(item)=>{ 
  setIsEditing(true)
  setEditItemId(item._id)
  setFormData({
    query:item.query,
    raisedBy:item.raisedBy,
    date:item.date,
    solved:item.solved,
    solvedDate:item.solvedDate
  })
}
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
        }));
      };

useEffect(()=>{
  fetchData()
},[customerId])

  
    const validateForm = () => {
      const requiredFields = [
        "query",
        "raisedBy",
        "date",
        
        
     
        
      ];
  
      for (const field of requiredFields) {
        if (!formData[field]) {
          return false;
        }
      }
      return true;
    };
//  const handleSubmit=async(e)=>{
//     e.preventDefault();
//     if(!validateForm()) {
//       toast.error("Please fill in all required fields.");
//       return;
//     }
//     setFormData({
//         name:formData.name,
//         address:formData.address,
//         phoneNo:formData.phoneNo,
//         gstIn:formData.gstIn,
//         openingBalance:formData.openingBalance,
//     })

//  }

    const save=async(e)=>{
        e.preventDefault();
        if(!validateForm()) {
          toast.error("Please fill in all required fields.");
          return;
        }
        try{
       if(isEditing){
        
          const response=await axios.put(`https://api.hotel.tdrsoftware.in/api/updateQuery/${customerId}/${editItemId}`,{data:formData})
          toast.success(response.data.message)
          setIsEditing(false)
          setEditItemId(null)
          
        
       }else{
        const response=await axios.post("https://api.hotel.tdrsoftware.in/api/createQuery",{
          customerId:customerId,data:formData
        });
       // console.log('Data Submitted: ',response.data);
        
        toast.success(response.data.message)
      }
        setFormData({
          query: "",
          raisedBy:"",
          date:"",
          solved:false,
        })
        fetchData()

      }catch(error){
        toast.error(error.meesage)
      }
    }
  //  console.log(formData,'formdata');
    
   // console.log(arr)
   
    //console.log(newObj);
   
    const openModal = (id) => {
      setDeleteItemId(id);
      setIsOpen(true);
    };
  
    const onClose = () => {
      setIsOpen(false);
      setDeleteItemId(null);
    };
    const handleDelete=async()=>{
     
      try {
        const response=await axios.delete(`https://api.hotel.tdrsoftware.in/api/deleteQuery/${customerId}/${deleteItemId}`)
        toast.success(response.data.message)
        setIsOpen(false)
        setDeleteItemId(null)
        fetchData()
      } catch (error) {
        toast.error(error.message)
      }
    }
    
return(
    <Box   bg='#EAE5DF '
          columns={{ sm: 2, md: 4 }}
          spacing='8'
          p='10'
          textAlign='center'
          
          
          color='black' width='100%' height='500px'   >
          <Text fontSize='2xl' fontWeight='bold' textAlign='center' color='black' mb={10}>Create Query</Text>
            
            <FormControl isRequired onSubmit={save}>
              <Box display="grid"  gridGap={1} >
            
                
                <Box
                  display="flex"
                  gap="10px"
                  alignItems="center"
                  justifyContent="space-evenly"
                  
                >
                  <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
                  borderRadius="5px"
                  p={4}>
                    <FormLabel fontSize=' sm'>Query</FormLabel>
                    <Input size='sm' w='72%'  bg='#FAFAFA ' placeholder="Enter Query" name='query' value={formData.query} onChange={handleInputChange}/>
                  </Box>
                 
                  <Box width="20%" display="flex" alignItems="center"  boxShadow='xl'
                  borderRadius="5px"
                  p={4}>
                    <FormLabel fontSize='sm'>Raised By</FormLabel>
                    <Input size='sm' w='65%' bg='#FAFAFA ' placeholder="Query RaisedBy" name='raisedBy' value={formData.raisedBy} onChange={handleInputChange}/>
                  </Box>
                  <Box width="20%" display="flex" alignItems="center"  boxShadow='xl'
                  borderRadius="5px"
                  p={4}>
                    <FormLabel fontSize='sm'>Date</FormLabel>
                    <Input type='date' size='sm' w='71%' bg='#FAFAFA ' placeholder="Enter Date" name='date' value={formData.date} onChange={handleInputChange}/>
                  </Box>
                  <Box width="20%" display="flex" alignItems="center"  boxShadow='xl'
                  borderRadius="5px"
                  p={4}>
                    {/* <FormLabel fontSize='sm'>CheckBox</FormLabel> */}
                    <Checkbox  size='sm' w='71%' bg='#FAFAFA ' placeholder="Enter Date" name='solved' isChecked={formData.solved} onChange={handleCheckboxChange}>Status</Checkbox>
                  </Box>
                   <Box width="20%" display="flex" alignItems="center"  boxShadow='xl'
                  borderRadius="5px"
                  p={4}>
                    <FormLabel fontSize='sm'>Solved Date</FormLabel>
                    <Input type='date' size='sm' w='65%' bg='#FAFAFA ' placeholder="Enter Date" name='solvedDate' value={formData.solvedDate} onChange={handleInputChange}/>
                  </Box>
                  </Box>
                  
                 
                
                
                
                
                
                  
                 
               
              
              </Box>
             
              {/* <Button type="submit" variant='solid' color='#0F172B' mr={3} bg='#FEA116' _hover={{color:'white'}} mt={5} onClick={handleSubmit}>Cash Bill</Button> */}
              <Button type="submit" variant='solid' color='#0F172B' bg='#FEA116' _hover={{color:'white'}} mt={5} onClick={save}>{isEditing ? "Update" : "Save"}</Button>
             
            </FormControl>
             <TableContainer width='full' mt={10} border='1px solid black' p={4} bg='white' borderRadius='10px' fontSize='sm'>
                            <Table size='sm' variant='striped' colorScheme='teal'>
                                <TableCaption>Item Data</TableCaption>
                                <Thead>
                                    <Tr >
                                        <Th >Query</Th>
                                        <Th>Raised By</Th>
                                        <Th>Date</Th>
                                        <Th>Status</Th>
                                        <Th>Solved Date</Th>
                                        
                                        
                                        <Th>Edit</Th>
                                        <Th>Delete</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {data?.map((item, index) => (
                                        <Tr key={index}>
                                            <Td>{item.query}</Td>
                                            <Td>{item.raisedBy}</Td>
                                            <Td>{item.date}</Td>
                                            <Td color={item.solved?"green":"red"}>{item.solved? "Solved" :"Not Solved"}</Td>
                                            <Td>{item.solvedDate}</Td>
                                           
                                            
                                            
                                            <Td><Button colorScheme="green" size="sm" onClick={() => edit(item)}>Edit</Button></Td>
                                            <Td><Button colorScheme="red" size="sm" onClick={() => openModal(item._id)}>Delete</Button></Td>
            
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                    <AlertDialogOverlay>
                      <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                          Confirm Deletion
                        </AlertDialogHeader>
            
                        <AlertDialogBody>Are you sure you want to delete this item?</AlertDialogBody>
            
                        <AlertDialogFooter>
                          <Button ref={cancelRef} onClick={onClose}>
                            Cancel
                          </Button>
                          <Button colorScheme="red" onClick={handleDelete} ml={3}>
                            Delete
                          </Button>
                        </AlertDialogFooter>
                      </AlertDialogContent>
                    </AlertDialogOverlay>
                  </AlertDialog>
                  
            </Box>
)
}
export default Maintanance